import { Node, mergeAttributes } from "@tiptap/core";
import { ReactNodeViewRenderer } from "@tiptap/react";
import { ChapterBreakNodeView } from "@/components/editor/nodeviews/ChapterBreakNodeView";

export const ChapterBreakBlock = Node.create({
  name: "chapterBreakBlock",
  group: "block",
  atom: true,

  addAttributes() {
    return {
      blockId: { default: null },
      label: { default: "" },
    };
  },

  parseHTML() {
    return [{ tag: 'div[data-type="chapter-break-block"]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return ["div", mergeAttributes(HTMLAttributes, { "data-type": "chapter-break-block" })];
  },

  addNodeView() {
    return ReactNodeViewRenderer(ChapterBreakNodeView);
  },
});
